import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { ConfirmPlacementEntryComponent } from "./confirm-placement-entry/confirm-placement-entry.component";
import {
  MatTableDataSource,
  MatPaginator,
  MatDialog,
  MatSelect
} from "@angular/material";

import { IBranch } from "src/app/interfaces/branch";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { BIDService } from "src/app/services/common/bid.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { PlacementService } from "./../../../services/http/business/placement/placement.service";
import { PlacementReservationEntryComponent } from "../placement-reservation-entry/placement-reservation-entry.component";
import { PlacementReportComponent } from "../placement-report/placement-report.component";
import { PlacementDetailComponent } from "./placement-detail/placement-detail.component";
import { PlacementSearchComponent } from "./placement-search/placement-search.component";
import * as moment from "jalali-moment";
import { environment } from "src/environments/environment";
import { HttpHeaders } from "@angular/common/http";
import { InvoiceSummaryComponent } from "../../finance/payment/invoice-summary/invoice-summary.component";

@Component({
  selector: "app-placement-reservation-list",
  templateUrl: "./placement-reservation-list.component.html",
  styleUrls: ["./placement-reservation-list.component.css"]
})
export class PlacementReservationListComponent implements OnInit, OnDestroy {
  UrlReport:string;
  isOwner: boolean;
  BranchEncryptId: string;
  branchList: IBranch[];
  companyList: ICompany[];
  hideTable: boolean = true;
  isPlacment: boolean = false;
  filter: any;

  displayedColumns: string[] = [
    this.translate.get("label.branch"),
    this.translate.get("label.fullname"),
    this.translate.get("label.nationalCode"),
    this.translate.get("label.placementReservationDate"),
    this.translate.get("label.timeSheetPlacement"),
    this.translate.get("label.placementReservationStatus"),
    "function"
  ];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private bidService: BIDService,
    private cidService: CIDService,
    public translate: TranslateService,
    private branchService: BranchService,
    private companyService: CompanyService,
    private holdingService: HoldingService,
    private placementService: PlacementService
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.getCompanyList();
    this.dataSource.paginator = this.paginator;
    this.UrlReport=environment.ReportBaseUrl+"Education/GetPlacmentReceiptShow?PlacementId=";
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (!res.IsOwner)
        this.loadPlacements(this.bidService.getBID());
    });
  }

  search() {
    this.dialog
      .open(PlacementSearchComponent, {
        width: '550px'
      })
      .afterClosed()
      .subscribe(res => {
        console.log(res);

        this.filter = res


        this.refresh();

      });
  }



  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }
  pay(data) {
    this.dialog.open(InvoiceSummaryComponent, {
      width: '98%',
      data: { Id: data.InvoiceId }
    })
      .afterClosed()
      .subscribe(() => {
        this.placementService
          .list(this.filter, this.BranchEncryptId, this.paginator.pageIndex + 1, this.paginator.pageSize)
          .subscribe(res => {
            this.dataSource = new MatTableDataSource(res.DataList);
            this.paginator.length = res.Total;
          });
      });
  }
  getBranchList(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );
    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(res => {
      this.branchList = res.DataList;
    });
  }

  setCid(e: MatSelect) {
    this.dataSource = null;
    this.cidService.setCID(e.value);
    this.getBranchList(e.value);
    this.filter = {
      BranchEncryptId: null
    }
    this.refresh();
  }

  loadTable(BranchEncryptId: MatSelect) {
    this.loadPlacements(BranchEncryptId.value)
  }

  loadPlacements(branchEncryptId: string) {
    this.dataSource = null;
    if (this.isOwner)
      this.bidService.setBID(branchEncryptId);
    this.BranchEncryptId = branchEncryptId;
    this.filter = {
      BranchEncryptId: branchEncryptId
    }
    this.refresh();

  }
  refresh() {

    // PlacementDateFrom: [null],
    // PlacementDateTo: [null],
    if (!this.isOwner) {
      if (this.filter) {
        if (!this.filter.BranchEncryptId)
          this.filter.BranchEncryptId = this.bidService.getBID();
      }
      else
        this.filter = {
          BranchEncryptId: this.bidService.getBID()
        }
    }


    if (this.filter && this.filter.PlacementDateFrom)
      this.filter.PlacementDateFrom = moment
        .from(this.filter.PlacementDateFrom, "en")
        .utc(true)
        .format(environment.dateFormat);

    if (this.filter && this.filter.PlacementDateFrom)
      this.filter.PlacementDateTo = moment
        .from(this.filter.PlacementDateTo, "en")
        .utc(true)
        .format(environment.dateFormat);


    this.placementService.list(this.filter, this.filter.BranchEncryptId, 1, 10).subscribe(res => {
      this.hideTable = false;
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }
  paginatorEvent(event) {
    this.placementService
      .list(this.filter, this.BranchEncryptId, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }
  add() {
    this.dialog
      .open(PlacementReservationEntryComponent)
      .afterClosed()
      .subscribe(() => {
        this.refresh();
        // this.placementService.list(this.filter, this.BranchEncryptId, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
        //   this.dataSource = res.DataList;
        //   this.paginator.length = res.Total;
        // });
      });
  }

  assign(e) {

    this.dialog
      .open(ConfirmPlacementEntryComponent, {
        data: e
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.placementService.list(this.filter, this.BranchEncryptId, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
            this.dataSource = res.DataList;
            this.paginator.length = res.Total;
          });
        }
      });
  }

  placementEdit(e) {

    this.dialog
      .open(ConfirmPlacementEntryComponent, {
        data: e
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.placementService.list(this.filter, this.BranchEncryptId, this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
            this.dataSource = res.DataList;
            this.paginator.length = res.Total;
          });
        }
      });
  }

  detail(e) {
    console.log(e);

    this.dialog
      .open(PlacementDetailComponent, {
        data: e,
        width: '400px'
      });

  }

  placementReport(e) {
    this.dialog
      .open(PlacementReportComponent, {
        data: e
      });
  }

  ngOnDestroy(): void {
    if (this.isOwner) {
      this.bidService.setBID("");
    }
  }
}
